import Model from '@tripian/model';
// import { init, api, providers } from '@tripian/core';
import LOCAL_STORAGE_KEYS from '../constants/LOCAL_STORAGE_KEYS';
// import { changeInitLoading } from '../redux/action/layout';
// import { loginFinally } from '../redux/action/user';
import config from '../config';

const clearLocalStorage = (): void => {
  const clearKeys = LOCAL_STORAGE_KEYS.CLEAR.split(',');
  clearKeys.forEach((clearKey) => {
    localStorage.removeItem(clearKey);
  });
};

const getLocalStorageToken = (): Model.Token | undefined => {
  try {
    const trptkn = localStorage.getItem(`${LOCAL_STORAGE_KEYS.TOKEN}-${config.name}`);
    if (trptkn) {
      const token: Model.Token = JSON.parse(trptkn) as Model.Token;
      return token;
    }

    return undefined;
  } catch (error) {
    return undefined;
  }
};

/* const removeLocalStorageToken = (): void => {
  localStorage.removeItem(`${LOCAL_STORAGE_KEYS.TOKEN}-${config.name}`);
}; */

// const initial = (dispatch: (action: any) => void) => {
//   clearLocalStorage();

//   const localToken = getLocalStorageToken();
//   init(config.TRIPIAN_API_URL, config.TRIPIAN_API_KEY, localToken, false);
//   providers.yelpInit();
//   if (config.TOUR_PROVIDER_SOURCE === Model.PROVIDER_ID.GLX || config.TICKET_PROVIDER_SOURCE === Model.PROVIDER_ID.GLX) providers.glxInit();
//   if (config.TOUR_PROVIDER_SOURCE === Model.PROVIDER_ID.GYG || config.TICKET_PROVIDER_SOURCE === Model.PROVIDER_ID.GYG) providers.gygInit();

//   if (localToken) {
//     api
//       .refreshToken()
//       .then((token) => {
//         if (!config.DONT_SAVE_TOKEN) localStorage.setItem(`${LOCAL_STORAGE_KEYS.TOKEN}-${config.name}`, JSON.stringify(token));
//         dispatch(loginFinally());
//         dispatch(fetchUser());
//       })
//       .catch(() => {
//         // TODO
//         // temp dont remove from browser for test..
//         // removeLocalStorageToken();
//       })
//       .finally(() => {
//         dispatch(changeInitLoading(false));
//       });
//   } else {
//     dispatch(changeInitLoading(false));
//   }
// };

export { clearLocalStorage, getLocalStorageToken };
